<app-header></app-header>
<div class="app-content visitor-pages">
					<div class="side-app ">
						<div class="row">
                              <div class="col-md-12 col-lg-12">
								<div class="">
									<!-- <div class="card-header">
										<h3 class="card-title">Carousel with controls</h3>
									</div> -->
									<div class="card-body">
										<div id="defaultCarousel23" class="owl-carousel Card-owlcarousel owl-carousel-icons-vis">
											
												<!-- <div class="carousel-item active">
												    <div class="backgrouimg"></div>
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-showroom-2.jpg" data-holder-rendered="true">-->
													<!-- <p>Marketplace to discover the best Cars </p> -->
												<!-- </div> -->
											<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/marsidi.jpg); background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
												
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/vehicle-banner.png);  background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
													
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												
												<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/gogoa-banner2.jpg);  background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												
												<!-- <div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<!-- <div class="backgrouimg1 " style="background: url(assets/images/banners/swift.png);  background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>  -->
												
												<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/Luxury-cars1.jpg); background-repeat: no-repeat; background-position: top; background-size: cover;"></div>
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												
												
											</div>
											<!-- <a class="carousel-control-prev" href="#carousel-controls" role="button" data-slide="prev">
												<span class="carousel-control-prev-icon" aria-hidden="true"></span>
												<span class="sr-only">Previous</span>
											</a>
											<a class="carousel-control-next" href="#carousel-controls" role="button" data-slide="next">
												<span class="carousel-control-next-icon" aria-hidden="true"></span>
												<span class="sr-only">Next</span>
											</a> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					
				</div>
        <!--/Breadcrumb-->

         <!--Section-->
        <div id="howItWorks">
         <section class="sptb  bg-white how-its-work-se">
           
                <div id="defaultCarousel" class="owl-carousel Card-owlcarousel owl-carousel-icons-vis">
			<div class="item">
				 <div class="container">
                <div class="section-title center-block text-center">
                    <h2>How it Works for Buyers </h2>
                    
                </div>
				<div class="d-md-flex">
                   
                        <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">Browse fresh inventory </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/search.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">View detail inspection report </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Inspection.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4 class=" mb-0 olw-header">Make an offer </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Vehicleview.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
                        </div>
                        
                    </div>
                   
                </div>				
				
				<div class="item">
				 <div class="container">
                <div class="section-title center-block text-center">
                    <h2>How it Works for Sellers  </h2>
                    
                </div>
				<div class="d-md-flex">
                   
                        <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">Upload your car for sale </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/search.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">Get free inspection  </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Inspection.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4 class=" mb-0 olw-header">Get Offers </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Vehicleview.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
                        </div>
                        
                    </div>
                   
                </div>
				
            </div>            
        </section>
        </div>
        <!--Section-->

        

        <!--section-->
        <section class="sptb chose-us-sec ">
            <div class="container">
                <div class="section-title center-block text-center">
                    <h2>Why Choose Us?</h2>
                </div>
                <div class="row ">
                    <div class="col-md-6 col-lg-3 features">
                        
                                <div class="feature">
                                    <div class="img-cener">
                                        <img src="assets/images/visitor/car.png">
                                    </div>
                                    <p>Extensive range of used car inventory</p>
                                </div>
							</div>
                        <div class="col-md-6 col-lg-3 features">
						<div class="feature">
							<div class="img-cener">
								<img src="assets/images/visitor/money.png"> </div>
                                    
									<p>Transparent deals</p>
                                   
                                
                        </div>
                    </div>    
						<div class="col-md-6 col-lg-3 features">
							<div class="feature">
                                     <div class="img-cener">
                                        <img src="assets/images/visitor/wrench.png">
                                    </div>
                                   
                                    <p>Okshan verified cars, detail inspection report</p>
                                </div>
							</div>                    
                    <div class="col-md-6 col-lg-3 features">
                       
                                <div class="feature">
                                     <div class="img-cener">
                                        <img src="assets/images/visitor/distance.png">
                                    </div>
                                    <p>Fully online deals across the country</p>
                                  </div>
                            
                    </div>
                   
                    
                </div>
            </div>
        </section>
        <!--/section-->

       
        <!--section-->
       <section class="sptb bg-white our-team-sec">
            <div class="container">
                <div class="section-title center-block text-center">
                    <h2>What our Associates Say</h2>
                  
                </div>
                <div class="row">
                    <div id="feature-carousel" class="owl-carousel owl-carousel-assoc-fix auction-content">
                    
                    <div class="item" *ngFor="let testimonial of testimonialList">
                    <div class="col-xl-12 col-md-12">
                        <div class="card mb-0 box-shadow2">
                            <div class="card-body">
                                <div class="team-section text-center">
                                    <div class="team-img">
                                         <img src="{{fileUrl+testimonial.image}}" class="img-thumbnail rounded-circle"  alt="">
                                    </div>
                                    <h4 class="font-weight-bold dark-grey-text mt-4">{{testimonial.user_name}}</h4>
                                    <h4 class="font-weight-bold dark-grey-text mt-4">{{testimonial.trade_name}}</h4>
                                   
                                    <p class="font-weight-Automatic dark-grey-text">
                                        <i class="fa fa-quote-left pr-2"></i>{{testimonial.message}} <i class="fa fa-quote-right pr-2"></i>
                                    </p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
        <!--/section-->	



          <!--section-->
       <section class="sptb bg-white our-team-sec">
        <div class="container">
            <div class="section-title center-block text-center">
                <h2>Media Coverage</h2>
              
            </div>
            <div class="row">
                <div id="feature-carousel" class="owl-carousel owl-carousel-assoc-fix auction-content">
                
              

                    
                <div class="item" >
                    <div class="col-xl-12 col-md-12">
                        <div class="card mb-0 box-shadow2">
                            <div class="card-body mediacardbody">
                                <div class="team-section text-center">
                                    <div class="mediacontainer">
                                         <img  src="assets/images/media2/et-logo.png" class="img-thumbnail imgmediap "  alt="">
                                        
                                        </div>
                                  
                                    <p class="font-weight-Automatic dark-grey-text mediatext">
                                        <a href="https://economictimes.indiatimes.com/industry/auto/auto-news/virtual-marketplace-okshan-forays-into-used-car-business-with-b2b-model/articleshow/82112585.cms
                                        " target="_blank" class="mediaheadinglink" >Virtual marketplace Okshan forays into used car business with B2B model </a>
                                    </p>
                                 
                                    <a href="https://economictimes.indiatimes.com/industry/auto/auto-news/virtual-marketplace-okshan-forays-into-used-car-business-with-b2b-model/articleshow/82112585.cms
                                    " target="_blank" class="mediadetlink" ><h6 class="font-weight-bold dark-grey-text mt-4 text-left">View full article   <i class="fa fa-angle-right pr-2"></i> </h6></a>
    

                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="item" >
                        <div class="col-xl-12 col-md-12">
                            <div class="card mb-0 box-shadow2">
                                <div class="card-body mediacardbody">
                                    <div class="team-section text-center">
                                        <div class="mediacontainer">
                                             <img  src="assets/images/media2/TOI.gif" class="img-thumbnail imgmediap "  alt="">
                                            
                                            </div>
                                      
                                        <p class="font-weight-Automatic dark-grey-text mediatext">
                                            <a href="https://timesofindia.indiatimes.com/auto/news/okshan-forays-into-used-car-biz-with-b2b-model/articleshow/82100635.cms" target="_blank" class="mediaheadinglink" > Okshan forays into used car biz with B2B model</a>
                                        </p>
                                     
                                        <a href="https://timesofindia.indiatimes.com/auto/news/okshan-forays-into-used-car-biz-with-b2b-model/articleshow/82100635.cms" target="_blank" class="mediadetlink" ><h6 class="font-weight-bold dark-grey-text mt-4 text-left">View full article   <i class="fa fa-angle-right pr-2"></i> </h6></a>
    
    
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                  
                        <div class="item" >
                            <div class="col-xl-12 col-md-12">
                                <div class="card mb-0 box-shadow2">
                                    <div class="card-body mediacardbody">
                                        <div class="team-section text-center">
                                            <div class="mediacontainer">
                                                 <img  src="assets/images/media2/TheNewzBox_LOGO_Final_Mobile_Retina.png" class="img-thumbnail imgmediap2 "  alt="">
                                                
                                                </div>
                                          
                                            <p class="font-weight-Automatic dark-grey-text mediatext">
                                                <a href="https://thenewzbox.in/automobile/virtual-marketplace-okshan-forays-into-used-car-business-with-b2b-model/" target="_blank" class="mediaheadinglink" >Virtual marketplace Okshan forays into used car business with B2B model</a>
                                            </p>
                                         
                                            <h6 class="font-weight-bold dark-grey-text mt-4 text-left">  <a href="https://thenewzbox.in/automobile/virtual-marketplace-okshan-forays-into-used-car-business-with-b2b-model/" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
        
        
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>                                                         
                            <div class="item" >
                                <div class="col-xl-12 col-md-12">
                                    <div class="card mb-0 box-shadow2">
                                        <div class="card-body mediacardbody">
                                            <div class="team-section text-center">
                                                <div class="mediacontainer">
                                                     <img  src="assets/images/media2/APN_News.png" class="img-thumbnail imgmediap"  alt="">
                                                     
                                                    </div>
                                              
                                                <p class="font-weight-Automatic dark-grey-text mediatext">
                                                    <a href="https://www.autocarpro.in/news-national/okshan-launches-digital-marketplace-for-b2b-used-cars-78975" target="_blank" class="mediaheadinglink" >Okshan launches digital marketplace for B2B used cars</a>
                                                </p>
                                             
                                                <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://www.autocarpro.in/news-national/okshan-launches-digital-marketplace-for-b2b-used-cars-78975" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
            
            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>

                                <div class="item" >
                                    <div class="col-xl-12 col-md-12">
                                        <div class="card mb-0 box-shadow2">
                                            <div class="card-body mediacardbody">
                                                <div class="team-section text-center">
                                                    <div class="mediacontainer">
                                                         <img  src="assets/images/media2/Autoloansale.png" class="img-thumbnail imgmediap "  alt="">
                                                        
                                                        </div>
                                                  
                                                    <p class="font-weight-Automatic dark-grey-text mediatext">
                                                        <a href="https://autoloanssale.com/2021/04/16/okshan-forays-into-used-car-biz-with-b2b-model-auto-news-et-auto/" target="_blank" class="mediaheadinglink" >Okshan forays into used car biz with B2B model, Auto News, ET Auto</a>
                                                    </p>
                                                 
                                                    <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://autoloanssale.com/2021/04/16/okshan-forays-into-used-car-biz-with-b2b-model-auto-news-et-auto/" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
                
                
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
    

                                    <div class="item" >
                                        <div class="col-xl-12 col-md-12">
                                            <div class="card mb-0 box-shadow2">
                                                <div class="card-body mediacardbody">
                                                    <div class="team-section text-center">
                                                        <div class="mediacontainer">
                                                             <img  src="assets/images/media2/Outlook.jpg" class="img-thumbnail imgmediap2"  alt="">
                                                           
                                                            </div>
                                                      
                                                        <p class="font-weight-Automatic dark-grey-text mediatext">
                                                            <a href="https://www.outlookindia.com/newsscroll/okshan-forays-into-used-car-biz-with-b2b-model/2065392" target="_blank" class="mediaheadinglink" > Okshan forays into used car biz with B2B model</a>
                                                        </p>
                                                     
                                                        <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://www.outlookindia.com/newsscroll/okshan-forays-into-used-car-biz-with-b2b-model/2065392" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
                    
                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>


                                        <div class="item" >
                                            <div class="col-xl-12 col-md-12">
                                                <div class="card mb-0 box-shadow2">
                                                    <div class="card-body mediacardbody">
                                                        <div class="team-section text-center">
                                                            <div class="mediacontainer">
                                                                 <img  src="assets/images/media2/Latestly.png" class="img-thumbnail imgmediap2"  alt="">
                                                                
                                                                </div>
                                                          
                                                            <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                <a href="https://www.latestly.com/agency-news/latest-news-okshan-forays-into-used-car-biz-with-b2b-model-2424680.html" target="_blank" class="mediaheadinglink" >Latest News | Okshan Forays into Used Car Biz with B2B Model</a>
                                                            </p>
                                                         
                                                            <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://www.latestly.com/agency-news/latest-news-okshan-forays-into-used-car-biz-with-b2b-model-2424680.html" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                        
                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                    
                                            <div class="item" >
                                                <div class="col-xl-12 col-md-12">
                                                    <div class="card mb-0 box-shadow2">
                                                        <div class="card-body mediacardbody">
                                                            <div class="team-section text-center">
                                                                <div class="mediacontainer">
                                                                     <img  src="assets/images/media2/htauto.png" class="img-thumbnail imgmediap2 h-115"  alt="">
                                                                   
                                                                    </div>
                                                              
                                                                <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                    <a href="https://auto.hindustantimes.com/auto/news/okshan-forays-into-used-car-biz-with-b2b-model-41618636515441.html" target="_blank" class="mediaheadinglink" > Okshan forays into used car biz with B2B model</a>
                                                                </p>
                                                             
                                                                <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://auto.hindustantimes.com/auto/news/okshan-forays-into-used-car-biz-with-b2b-model-41618636515441.html" target="_blank" class="mediadetlink" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                            
                            
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>





                                                <div class="item" >
                                                    <div class="col-xl-12 col-md-12">
                                                        <div class="card mb-0 box-shadow2">
                                                            <div class="card-body mediacardbody">
                                                                <div class="team-section text-center">
                                                                    <div class="mediacontainer">
                                                                         <img  src="assets/images/media2/FinancialExpress.png" class="img-thumbnail imgmediap2"  alt="">
                                                                         
                                                                        </div>
                                                                  
                                                                    <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                        <a href="https://www.financialexpress.com/auto/car-news/indias-first-b2b-used-car-marketplace-okshan-real-time-bidding-used-maruti-used-hyundai-used-volkswagen/2234222/" target="_blank" class="mediaheadinglink" >  India’s first B2B used car marketplace launched: Okshan to facilitate realtime...</a>
                                                                    </p>
                                                                 
                                                                    <a href="https://www.financialexpress.com/auto/car-news/indias-first-b2b-used-car-marketplace-okshan-real-time-bidding-used-maruti-used-hyundai-used-volkswagen/2234222/" target="_blank" class="mediadetlink" ><h6 class="font-weight-bold dark-grey-text mt-4 text-left">View full article   <i class="fa fa-angle-right pr-2"></i> </h6></a>
                                
                                
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                   
                                                        <div class="item" >
                                                            <div class="col-xl-12 col-md-12">
                                                                <div class="card mb-0 box-shadow2">
                                                                    <div class="card-body mediacardbody">
                                                                        <div class="team-section text-center">
                                                                            <div class="mediacontainer">
                                                                                 <img  src="assets/images/media2/autoET.png" class="img-thumbnail imgmediap2"  alt="">
                                                                                
                                                                                </div>
                                                                          
                                                                            <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                <a href="https://auto.economictimes.indiatimes.com/news/passenger-vehicle/cars/okshan-forays-into-used-car-biz-with-b2b-model/82094690" target="_blank" class="mediaheadinglink" > Okshan forays into used car biz with B2B model</a>
                                                                            </p>
                                                                         
                                                                            <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://auto.economictimes.indiatimes.com/news/passenger-vehicle/cars/okshan-forays-into-used-car-biz-with-b2b-model/82094690" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                                        
                                        
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                           
                                                                    <div class="item" >
                                                                        <div class="col-xl-12 col-md-12">
                                                                            <div class="card mb-0 box-shadow2">
                                                                                <div class="card-body mediacardbody">
                                                                                    <div class="team-section text-center">
                                                                                        <div class="mediacontainer">
                                                                                             <img  src="assets/images/media2/BW-Autoworld-logo.jpg" class="img-thumbnail imgmediap2"  alt="">
                                                                                            
                                                                                            </div>
                                                                                      
                                                                                        <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                            <a href="http://bwautoworld.businessworld.in/article/Okshan-Launches-B2B-Used-Car-Marketplace/15-04-2021-386717/" target="_blank" class="mediaheadinglink" >Okshan has so far signed-up over 3000 brokers and 200 new car dealers on...</a>
                                                                                        </p>
                                                                                     
                                                                                        <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="http://bwautoworld.businessworld.in/article/Okshan-Launches-B2B-Used-Car-Marketplace/15-04-2021-386717/" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                                                    
                                                    
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        </div>
                    
                                                                        <div class="item" >
                                                                            <div class="col-xl-12 col-md-12">
                                                                                <div class="card mb-0 box-shadow2">
                                                                                    <div class="card-body mediacardbody">
                                                                                        <div class="team-section text-center">
                                                                                            <div class="mediacontainer">
                                                                                                 <img  src="assets/images/media2/cartrade_logo_238-48.png" class="img-thumbnail imgmediap2"  alt="">
                                                                                                
                                                                                                </div>
                                                                                          
                                                                                            <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                <a href="https://www.cartrade.com/news/okshan-introduces-b2b-used-car-marketplace-in-india-137725.html" target="_blank" class="mediaheadinglink" >Okshan introduces B2B used-car marketplace in India </a>
                                                                                            </p>
                                                                                         
                                                                                           <h6 class="font-weight-bold dark-grey-text mt-4 text-left"> <a href="https://www.cartrade.com/news/okshan-introduces-b2b-used-car-marketplace-in-india-137725.html" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                                                        
                                                        
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            </div>
                    
                    
                                                                               
                                                                                <div class="item" >
                                                                                    <div class="col-xl-12 col-md-12">
                                                                                        <div class="card mb-0 box-shadow2">
                                                                                            <div class="card-body mediacardbody">
                                                                                                <div class="team-section text-center">
                                                                                                    <div class="mediacontainer">
                                                                                                         <img  src="assets/images/media2/news18.png" class="img-thumbnail imgmediap2 h-115 "  alt="">
                                                                                                        
                                                                                                        </div>
                                                                                                  
                                                                                                    <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                        <a href="https://www.news18.com/news/auto/virtual-marketplace-okshan-forays-into-used-car-business-in-india-with-unique-b2b-model-3649199.html" target="_blank" class="mediaheadinglink" >Virtual Marketplace Okshan Forays into Used Car Business in India With Unique B2B...</a>
                                                                                                    </p>
                                                                                                 
                                                                                                    <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://www.news18.com/news/auto/virtual-marketplace-okshan-forays-into-used-car-business-in-india-with-unique-b2b-model-3649199.html" target="_blank" class="mediadetlink" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                                                                
                                                                
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    </div>
                                                                                <div class="item" >
                                                                                    <div class="col-xl-12 col-md-12">
                                                                                        <div class="card mb-0 box-shadow2">
                                                                                            <div class="card-body mediacardbody">
                                                                                                <div class="team-section text-center">
                                                                                                    <div class="mediacontainer">
                                                                                                         <img  src="assets/images/media2/logo-cambay-post.png" class="img-thumbnail imgmediap2 h-115"  alt="">
                                                                                                        
                                                                                                        </div>
                                                                                                  
                                                                                                    <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                        <a href="https://www.thecambaypost.com/okshan-launches-b2b-used-car-marketplace/" target="_blank" class="mediaheadinglink" >Okshan, India’s first and only B2B virtual marketplace, has forayed into the country’s used car market.</a>
                                                                                                    </p>
                                                                                                 
                                                                                                    <h6 class="font-weight-bold dark-grey-text mt-2 text-left"><a href="https://www.thecambaypost.com/okshan-launches-b2b-used-car-marketplace/" target="_blank" class="request_tour1 t-0" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                                                                
                                                                
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    </div>
                    
                                                                                  
                    
                                                                                        <div class="item" >
                                                                                            <div class="col-xl-12 col-md-12">
                                                                                                <div class="card mb-0 box-shadow2">
                                                                                                    <div class="card-body mediacardbody">
                                                                                                        <div class="team-section text-center">
                                                                                                            <div class="mediacontainer">
                                                                                                                 <img  src="assets/images/media2/devdiscourse_logo.svg" class="img-thumbnail imgmediap2 "  alt="">
                                                                                                                
                                                                                                                </div>
                                                                                                          
                                                                                                            <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                                <a href="https://www.devdiscourse.com/article/business/1535991-okshan-forays-into-used-car-biz-with-b2b-model" target="_blank" class="mediaheadinglink" > Okshan forays into used car biz with B2B model</a>
                                                                                                            </p>
                                                                                                         
                                                                                                            <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://www.devdiscourse.com/article/business/1535991-okshan-forays-into-used-car-biz-with-b2b-model" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i></a> </h6>
                                                                        
                                                                        
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            </div>
                    
                                                                                            <div class="item" >
                                                                                                <div class="col-xl-12 col-md-12">
                                                                                                    <div class="card mb-0 box-shadow2">
                                                                                                        <div class="card-body mediacardbody">
                                                                                                            <div class="team-section text-center">
                                                                                                                <div class="mediacontainer">
                                                                                                                     <img  src="assets/images/media2/Autobala1.png" class="img-thumbnail imgmediap3"  alt="">
                                                                                                                    
                                                                                                                    </div>
                                                                                                              
                                                                                                                <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                                    <a href="https://autobala.com/okshan-launches-digital-marketplace-for-b2b-used-cars/13575/" target="_blank" class="mediaheadinglink" > Okshan Launches Digital Marketplace for B2B Used Cars</a>
                                                                                                                </p>
                                                                                                             
                                                                                                                <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://autobala.com/okshan-launches-digital-marketplace-for-b2b-used-cars/13575/" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
                                                                            
                                                                            
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                </div>
                    

                                                                                                <div class="item" >
                                                                                                    <div class="col-xl-12 col-md-12">
                                                                                                        <div class="card mb-0 box-shadow2">
                                                                                                            <div class="card-body mediacardbody">
                                                                                                                <div class="team-section text-center">
                                                                                                                    <div class="mediacontainer">
                                                                                                                         <img  src="assets/images/media2/dailyNews.png" class="img-thumbnail imgmediap3 h-110 "  alt="">
                                                                                                                        
                                                                                                                        </div>
                                                                                                                  
                                                                                                                    <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                                        <a href="https://autobala.com/okshan-launches-digital-marketplace-for-b2b-used-cars/13575/" target="_blank" class="mediaheadinglink" >India’s first B2B used automobile market launched: Okshan to facilitate realtime... </a>
                                                                                                                    </p>
                                                                                                                 
                                                                                                                    <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://dailynews24hour.com/indias-first-b2b-used-automobile-market-launched-okshan-to-facilitate-real-time-bidding/" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
                                                                                
                                                                                
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    </div>

                                                                                        
                    
                                                                                                  
                    
                                                                                                        <div class="item" >
                                                                                                            <div class="col-xl-12 col-md-12">
                                                                                                                <div class="card mb-0 box-shadow2">
                                                                                                                    <div class="card-body mediacardbody">
                                                                                                                        <div class="team-section text-center">
                                                                                                                            <div class="mediacontainer">
                                                                                                                                 <img  src="assets/images/media2/cropped-LOGO_NEWS_99-3.png" class="img-thumbnail imgmediap3 h-115 "  alt="">
                                                                                                                                
                                                                                                                                </div>
                                                                                                                          
                                                                                                                            <p class="font-weight-Automatic dark-grey-text mediatext">
                                                                                                                                <a href="https://news99india.in/digital-market-okshan-forays-into-used-automobile-enterprise-with-b2b-mannequin/" target="_blank" class="mediaheadinglink" > Digital market Okshan forays into used automobile enterprise with B2B mannequin</a>
                                                                                                                            </p>
                                                                                                                         
                                                                                                                            <h6 class="font-weight-bold dark-grey-text mt-4 text-left"><a href="https://news99india.in/digital-market-okshan-forays-into-used-automobile-enterprise-with-b2b-mannequin/" target="_blank" class="request_tour1" >View full article   <i class="fa fa-angle-right pr-2"></i> </a></h6>
                                                                                        
                                                                                        
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            </div>
                    



            </div>
        </div>
        </div>
    </section>
    <!--/section-->	

        
        
        <app-footer></app-footer>